import React from "react";
import { Table, TableHead, TableCell, TableRow, TableBody } from "@material-ui/core";

import { Values } from "Tools/Values";

import { STPaper } from "@src/Components/Ui/STPaperOverflow";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import { Theme } from "@src/Interfaces/Entity/Theme";
import ThemeTableItem from "./ThemeTableItem/ThemeTableItem";
import { inject } from "mobx-react";
import { IAuthStore } from "@src/Stores/Auth/types";

interface IProps {
  themes: Theme[];
  auth?: IAuthStore;
}

@inject("auth")
export default class ThemesTable extends React.Component<IProps> {
  render() {
    return (
      <STPaper elevation={2}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("description")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("type")}</STTableHeadTypography>
              </TableCell>
              <TableCell>
                <STTableHeadTypography>{Values.getLocalizationValue("nightTheme")}</STTableHeadTypography>
              </TableCell>
              {this.props.auth.user.location.primary && (
                <>
                  <TableCell>
                    <STTableHeadTypography>{Values.getLocalizationValue("location")}</STTableHeadTypography>
                  </TableCell>
                  <TableCell>
                    <STTableHeadTypography>{Values.getLocalizationValue("default")}</STTableHeadTypography>
                  </TableCell>
                </>
              )}
              <TableCell align="right" />
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.themes.map((theme: Theme) => {
              return <ThemeTableItem key={theme.id} theme={theme} />;
            })}
          </TableBody>
        </Table>
      </STPaper>
    );
  }
}
